import $ from "jquery";

// Register the client-side validation logic
$.validator.addMethod("validforbund", function (value, element, params) {
    if (value === "") {
        return true; // Allow empty if not required
    }

    // Split the valid options into an array
    var validOptions = params.split(',');
    // Check if the value is one of the valid options
    return validOptions.includes(value);
});

$.validator.unobtrusive.adapters.add("validforbund", ["validoptions"], function (options) {
    var element = options.element;
    var validOptions = options.params.validoptions;

    // Pass the valid options to the validation method
    options.rules["validforbund"] = validOptions;
    options.messages["validforbund"] = options.message;
});